import { render, staticRenderFns } from "./addWelcomeVideo.vue?vue&type=template&id=1412261d&"
import script from "./addWelcomeVideo.vue?vue&type=script&lang=js&"
export * from "./addWelcomeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports